import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Global time-window crop for an SHM measurement. Closes with
 * `{ startTs: string | null; endTs: string | null }` (ISO strings, null = no
 * bound) or `undefined` on cancel.
 *
 * config.data: { min: Date; max: Date; current: { startTs: Date | null; endTs: Date | null } }
 */
@Component({
  selector: 'cosmos-shm-reschedule-dialog',
  imports: [FormsModule, TranslatePipe, ButtonModule, DatePickerModule],
  templateUrl: './shm-reschedule-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShmRescheduleDialogComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);

  readonly minDate = this.config.data?.min as Date | undefined;
  readonly maxDate = this.config.data?.max as Date | undefined;

  readonly start = signal<Date | null>(this.config.data?.current?.startTs ?? this.minDate ?? null);
  readonly end = signal<Date | null>(this.config.data?.current?.endTs ?? this.maxDate ?? null);

  get startModel() { return this.start(); }
  set startModel(v: Date | null) { this.start.set(v); }
  get endModel() { return this.end(); }
  set endModel(v: Date | null) { this.end.set(v); }

  apply(): void {
    this.ref.close({
      startTs: this.start() ? this.start()!.toISOString() : null,
      endTs: this.end() ? this.end()!.toISOString() : null,
    });
  }

  clear(): void {
    this.ref.close({ startTs: null, endTs: null });
  }

  cancel(): void {
    this.ref.close(undefined);
  }
}
